import { MFase } from './fase.model';
import { MEvaluationCreator } from './evaluation-creator.model';
import { Responsible } from '../interfaces/treatment';

export class MResponsible{

    public fase: MFase = null;
    public limitDate: string | Date = null;
    public id: number = null;
    public user: MEvaluationCreator = null;
    public amountOfDays: number = 0;

    constructor(resp: Responsible){
        this.fase = new MFase(resp.fase);
        this.limitDate = resp.fecha_limite ? resp.fecha_limite.substr(0, resp.fecha_limite.indexOf(' ')) : null;
        this.id = resp.id;
        this.user = new MEvaluationCreator(resp.usuario_responsable)
        this.amountOfDays = resp.plazo_dias ? resp.plazo_dias : 0
    }

}